module.exports = __webpack_public_path__ + "static/media/rice.4a13fef1.png";